
import { supplyChainMapPoints, SupplyChainMapPoint } from '@/config/supplyChainMapPoints';
import supplyChainBg from '@/assets/images/supply-chain-bg.png';
import './SupplyChainMap.css';

function MapPin({ point, onClick }: { point: SupplyChainMapPoint; onClick: () => void }) {
  const pinClass = `supply-chain-pin supply-chain-pin--${point.pinColor}`;
  return (
    <button
      type="button"
      className={pinClass}
      style={{ left: `${point.left}%`, top: `${point.top}%` }}
      onClick={onClick}
      aria-label={`${point.name}：${point.description}`}
    >
      <span className="supply-chain-pin__marker">
        <span className="supply-chain-pin__dot" />
      </span>
      <span className="supply-chain-pin__label">{point.name}</span>
    </button>
  );
}

export default function SupplyChainMap() {

  return (
    <div className="supply-chain-map-page">
      <div className="supply-chain-map-container">
        <div
          className="supply-chain-map-bg"
          style={{ backgroundImage: `url(${supplyChainBg})` }}
        />
        <div className="supply-chain-map-pins">
          {supplyChainMapPoints.map((point) => (
            <MapPin
              key={point.id}
              point={point}
              onClick={() => window.open(point.path, '_blank')}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
